var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collectionEngineV1 } from '../apis';
const documentsV1API = collectionEngineV1('/documents');
export const add = (refId, type, refIdType, fileId, isSigned, signedAt, date, minAccessRole, meta) => documentsV1API('POST', `/`, {
    body: {
        refId,
        type,
        fileId,
        isSigned,
        signedAt,
        date,
        minAccessRole,
        meta,
        refIdType,
    },
});
export const get = (refId, casualConsistency) => documentsV1API('GET', `/${refId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const update = (documentId, document) => documentsV1API('PATCH', '/' + documentId, {
    body: document,
});
export const del = (documentId) => documentsV1API('DELETE', '/' + documentId);
export const getLinkToSignDocument = (documentId, role, name, successURL) => __awaiter(void 0, void 0, void 0, function* () {
    return documentsV1API('GET', `/get-signing-link/${encode(documentId)}/${encode(role)}/${encode(name)}?successURL=${successURL ? encode(successURL) : ''}`);
});
const encode = (s) => encodeURIComponent(encodeURIComponent(s));
//# sourceMappingURL=documents.js.map